import {
  createBarDatasetConfig,
  createSkillSetChartOptions
} from '@utils/chartConfig'
import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'

import { Entities_Assessment_SkillSetsPercentAggregateByLevel_Details } from '@suntex.fim/api-client'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)
const options = createSkillSetChartOptions(false)
const labels = ['1', '2', '3', '4', '5', '6', '7', '8']

/**
 * returns JSX for assessment skill set chart
 */
function AssessmentSkillSetCharts({
  backgroundColor,
  chartData = {}
}: {
  backgroundColor: string
  chartData: Entities_Assessment_SkillSetsPercentAggregateByLevel_Details['ss']
}) {
  const data: ChartData<'bar', number[], string> = {
    labels,
    datasets: [
      {
        data: labels.map((label) => chartData[label] ?? 0),
        ...createBarDatasetConfig(backgroundColor)
      }
    ]
  }

  return <Bar options={options} data={data} />
}

export default AssessmentSkillSetCharts
